export const ATTENDEES = [
  {
    id: 1,
    name: 'Dr. Ahmed Al-Bishi',
    role: 'Delegation Lead',
    department: 'College of Computer Science',
    focus: 'Business & Partnerships',
    responsibility: 'Ask what problem they solve and who buys it. Lead agreement meetings.',
    email: 'a.albishi@ub.edu.sa',
    status: 'confirmed',
  },
  {
    id: 2,
    name: 'Eng. Fahad Al-Qahtani',
    role: 'AI Engineer',
    department: 'College of Computer Science',
    focus: 'Technical',
    responsibility: 'Ask about AI architecture, LLMs, agents, RAG, and enterprise deployment.',
    email: 'f.alqahtani@ub.edu.sa',
    status: 'confirmed',
  },
  {
    id: 3,
    name: 'Eng. Sarah Al-Dossari',
    role: 'Software Developer',
    department: 'College of Computer Science',
    focus: 'Technical',
    responsibility: 'Evaluate APIs, SDKs, developer integration, and on-premise AI options.',
    email: 's.aldossari@ub.edu.sa',
    status: 'confirmed',
  },
  {
    id: 4,
    name: 'Mr. Khalid Al-Ghamdi',
    role: 'Relations Coordinator',
    department: 'University Relations',
    focus: 'Networking',
    responsibility: 'Collect names, LinkedIn, WhatsApp, and schedule follow-up meetings.',
    email: 'k.alghamdi@ub.edu.sa',
    status: 'confirmed',
  },
  {
    id: 5,
    name: 'Dr. Noura Al-Harbi',
    role: 'EdTech Researcher',
    department: 'College of Education',
    focus: 'Sessions & EdTech',
    responsibility: 'Prioritize AI/education sessions and assess learning platform partnerships.',
    email: 'n.alharbi@ub.edu.sa',
    status: 'pending',
  },
];

export const TRIP_INFO = {
  event: 'LEAP 2026',
  university: 'جامعة بيشة',
  shortName: 'UB',
  dates: '31 أغسطس – 3 سبتمبر 2026',
  venue: 'مركز واجهة الرياض للمعارض والمؤتمرات',
  mapsUrl: 'https://maps.app.goo.gl/JChC5WFHcZZntAVn8',
  hours: '12:00 م – 9:00 م يومياً',
  teamSize: '4–5 delegates',
  strategy: '3–5 meaningful AI conversations per day. Focus on agreements, high-value AI companies, and targeted sessions.',
};
